import * as collection from 'BASE/common/collection/collection';
import Constant from 'BASE/common/lotteryConstant';
import CollectionLink from 'CJ/components/topHeader.component.collection';

export default {
    mixins: [ CollectionLink ],
    data() {
        return {
            display:false,
            maxCollect: 4,
            tempCollectedFunction: [],
        };
    },
    computed: {
        // Override
        CollectedFunctions() {
            let result = [];
            for (let link of this.tempCollectedFunction) {
                let func = this.AllFunctions.find(f => f.href == link);
                if (func) {             
                    result.push(func);
                }
            }
            return result;
        },
        DisplayMyAccount() {
            return this.MyAccount.filter(func => {
                if (this.checkCollection(func)) {
                    return func
                }                
            });
        },
        DisplayReportCenter() {
            return this.ReportCenter.filter(func => {
                if (this.checkCollection(func)) {
                    return func
                }                
            });
        },
        DisplayCashCenter() {
            return this.CashCenter;
        },
        DisplayTeamCenter() {
            return this.TeamCenter.filter(func => {
                if (this.checkCollection(func)) {
                    return func
                }           
            });
        },
        isAgent(){
            return this.$store.state.userinfo.isAgent;
        },
    },
    methods: {
        switchCollect(link){
            let index = this.tempCollectedFunction.indexOf(link);
            if(index < 0) {
                if (this.tempCollectedFunction.length < this.maxCollect) {
                    this.tempCollectedFunction.push(link);
                } else {
                    this.$dialog.warning("快捷功能已满");
                }
            }
            else if (index >= 0) {
                this.tempCollectedFunction.splice(index, 1);
            }
        },
        deleteCollect(link) {
            let index = this.tempCollectedFunction.indexOf(link);
            if (index >= 0) {
                this.tempCollectedFunction.splice(index, 1);
            }
        },
        checkCollection (link){   //檢查已收集的權限，是否顯示
            if (link.checkId) {
                if(!this.ShowFunction(link.checkId)) {
                    //刪除按鈕,避免佔住一個隱藏的位置,造成無法新增其他按鈕
                    this.deleteCollect(link.href)
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        async saveCollected() {
            this.display = false;
            await collection.setCollection(this.$store.state.userinfo.userName, this.tempCollectedFunction, Constant.CollectionType.FUNCTION);
            if(this.$parent && this.$parent.updateCollection)
            {
                await this.$parent.updateCollection();
            }
        },
        ShowFunction(id){ //檢查權限，是否顯示
            switch (id) {
                case this.checkFunction.isAgent:
                    return this.$store.state.userinfo.isAgent;
                case this.checkFunction.bonusManagementAllowed:
                    return this.$store.state.userinfo.privileges.bonusManagementAllowed;
                case this.checkFunction.haveMyDailyPayAndContract:
                    return this.$store.state.userinfo.privileges.haveMyDailyPayAndContract;
                case this.checkFunction.contractPermission:
                    return this.$store.state.userinfo.privileges.contractPermission.length > 0;
                case this.checkFunction.haveProportionalDividend:
                    return this.$store.state.userinfo.privileges.haveProportionalDividend;
                case this.checkFunction.TransferPointEnabled:
                    return this.$store.state.userinfo.privileges.isTransferPointEnabled;
                default: 
                    return true;
            }
        },
    },
    watch: {
        collectedFunction() {
            this.tempCollectedFunction = this.collectedFunction.slice();
        }
    }
};
